var map = {
	"./1.png": 6634,
	"./2.png": 7217,
	"./3.png": 9736,
	"./4.png": 3965,
	"./5.png": 3150,
	"./6.png": 3509,
	"./7.png": 620,
	"./8.png": 107,
	"./AI.png": 2273,
	"./Global.png": 9302,
	"./about-hero.jpg": 6971,
	"./article1.jpg": 3156,
	"./article2.jpg": 1283,
	"./article3.jpg": 2758,
	"./articles-hero.jpg": 589,
	"./backend1.jpeg": 5011,
	"./backend2.jpeg": 3078,
	"./background.jpg": 5671,
	"./book-cover.jpg": 9078,
	"./book-hero.jpg": 4856,
	"./building.jpg": 6787,
	"./client-logo1.png": 9419,
	"./client-logo2.png": 1856,
	"./client-logo3.png": 6057,
	"./client-logo4.png": 6086,
	"./contact us.png": 1411,
	"./contact-hero.jpg": 8306,
	"./event_card_grassland.png": 9186,
	"./event_card_river.png": 1693,
	"./event_featured_sunset.png": 8293,
	"./events_header_collage.png": 1736,
	"./logo.png": 2806,
	"./logo1.png": 2861,
	"./logoy.jpeg": 4922,
	"./podcast-hero.jpg": 8898,
	"./podcast1.jpg": 3442,
	"./podcast2.jpg": 6349,
	"./podcast3.jpg": 1776,
	"./promble.jpeg": 4811,
	"./references-hero.jpg": 6068,
	"./service-ai.png": 7939,
	"./service-global.png": 3068,
	"./service-risk.png": 1224,
	"./service-sustainable.png": 5798,
	"./service_gov_advisory.png": 6469,
	"./service_implementation.png": 1945,
	"./service_industry_solutions.png": 4032,
	"./services-hero.jpg": 1854,
	"./stories-hero.jpg": 7511,
	"./story1.jpg": 5223,
	"./story2.jpg": 1416,
	"./team-member.jpg": 2881,
	"./截图 2025-12-07 12-06-31.png": 7423
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3811;